import React from 'react';
import ReactMarkdown from 'react-markdown';

export default function TailwindMarkdown({ source }) {
  const componentsMap = {
    a: ({ node, ...props }) => <a className="text-purple-600 cursor-pointer" {...props} />,
    strong: ({ node, ...props }) => <span className="font-bold" {...props} />,
    em: ({ node, ...props }) => <span className="italic" {...props} />,
    p: ({ node, ...props }) => <p className="mb-4" {...props} />,
    code: ({ node, inline, ...props }) => inline ? <span className="bg-yellow-100" {...props} /> : <p className="bg-yellow-100 p-2 text-gray-900" {...props} />,
    pre: ({ node, inline, ...props }) => inline ? <span className="bg-yellow-100" {...props} /> : <p className="bg-yellow-100 p-2" {...props} />,
    h1: ({ node, ...props }) => <h1 className="mb-4 text-4xl font-bold" {...props} />,
    h2: ({ node, ...props }) => <h2 className="mb-4 text-3xl font-bold" {...props} />,
    h3: ({ node, ...props }) => <h3 className="mb-4 text-2xl font-bold" {...props} />,
    h4: ({ node, ...props }) => <h4 className="mb-4 text-xl font-semibold" {...props} />,
    h5: ({ node, ...props }) => <h5 className="mb-4 text-lg font-semibold" {...props} />,
    h6: ({ node, ...props }) => <h6 className="mb-4 font-semibold" {...props} />,
    blockquote: ({ node, ...props }) => <div className="px-4 pt-5 pb-1 my-4 bg-gray-50 shadow text-gray-800" {...props} />,
    ul: ({ node, ordered, ...props }) => <ul className="mb-4 list-disc list-inside" {...props} />,
    ol: ({ node, ordered, ...props }) => <ol className="mb-4 list-decimal list-inside" {...props} />,
    li: ({ node, ordered, ...props }) => <li className="mb-3" {...props} />,
  };

  return (
    <ReactMarkdown
      components={componentsMap}
      children={source}
    />
  );
}
